import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  id: '',
  open: false,
  payload: {},
  confirmed: false
};

export const modalsSlice = createSlice({
  name: '@@modals',
  initialState,
  reducers: {
    MODAL_CLOSE: state => ({
      ...initialState
    }),
    MODAL_OPEN: (state, action) => ({ ...action.payload, open: true }),
    RESET_STATE: () => initialState,
    SET_CONFIRMED: (state, action) => ({ confirmed: action.payload })
  }
});

export const {
  MODAL_CLOSE,
  MODAL_OPEN,
  RESET_STATE,
  SET_CONFIRMED
} = modalsSlice.actions;

export default modalsSlice.reducer;
